import React from "react";

type Props = {
	img?: string;
	label: string;
	bgColor: string;
	disabled?: boolean;
	size?: string;
	className?: string;
	onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

const Button = ({
	img,
	label,
	bgColor,
	disabled = false,
	onClick,
	size = "md",
	className,
}: Props) => {
	const sizeDimensions = {
		sm: "px-[1vh] py-[0.5vh]",
		md: "px-[2.5vh] py-[1vh]",
	};

	return (
		<span
			onClick={onClick}
			className={`${className} flex gap-[min(0.4vw,5%)] justify-start items-center text-white ${
				sizeDimensions[size as keyof typeof sizeDimensions]
			} rounded-md ${
				disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"
			}`}
			style={{ backgroundColor: bgColor }}
		>
			{img && <img src={img} alt={label} style={{ width: "1vw" }} />}
			<span className="font-bold text-fs12 flex justify-center w-full">
				{label}
			</span>
		</span>
	);
};

export default Button;
